import { WSQueryCache } from "@ws-react-query";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";
import { QUERY_VERIFICATION_MISSING_DATA } from "../../../query/onboarding/queries/useQueryVerificationMissingFields";
import { QUERY_VERIFICATIONS } from "../../../query/onboarding/queries/useQueryVerifications";
import { getVerificationMissingData } from "../../../services/api/onboarding/missingFields";
import { getVerifications } from "../../../services/api/onboarding/verifications";
import { verificationService } from "../../../shared/services/verificaiton";

export type VerificationState = {
  status: onboardingApiSpec.VerificationStatus;
  usPersonStatus: onboardingApiSpec.VerificationStatus;
  missingData: onboardingApiSpec.operations["getVerificationMissingData"]["responses"]["200"]["content"]["application/json"];
};

export async function getVerificationState(
  verificationLevel: onboardingApiSpec.ParameterVerificationLevel
) {
  const [verifications, missingData] = await Promise.all([
    getVerifications(),
    getVerificationMissingData(verificationLevel)
  ]);

  WSQueryCache.setQueryData(
    [QUERY_VERIFICATION_MISSING_DATA, verificationLevel],
    missingData
  );
  WSQueryCache.setQueryData(QUERY_VERIFICATIONS, verifications);

  const status = verificationService.getVerificationStatus(
    verificationLevel,
    verifications
  );

  const usPersonStatus = verificationService.getUSPersonVerificationStatus(
    "Tax",
    verifications
  );

  return {
    status,
    usPersonStatus,
    missingData
  };
}
